import { render, staticRenderFns } from "./TableforClients.vue?vue&type=template&id=65643b5f&scoped=true"
import script from "./TableforClients.vue?vue&type=script&lang=js"
export * from "./TableforClients.vue?vue&type=script&lang=js"
import style0 from "./TableforClients.vue?vue&type=style&index=0&id=65643b5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65643b5f",
  null
  
)

export default component.exports